import interpolateStringToTemplate from './interpolate-string-to-template';

const normalizeContext = ({ colors, palettes, ...rest }) => ({ ...colors, ...palettes, ...rest });

const parseTemplate = (template, context) =>
  JSON.parse(interpolateStringToTemplate(JSON.stringify(template), normalizeContext(context)));

export default parseTemplate;
